export * from './signup-accordion.styled.default';
